module.exports = __webpack_public_path__ + "static/img/Xavier-Cooks.9e89112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Xavier-Cooks.jpg
// module id = Izg7
// module chunks = 1